import makeAuditBackendApi from '@counsel-project/counsel-audit-backend-api'
import { url } from './url'

export const auditBackendRequest = makeAuditBackendApi({
  url: url + '/audit-backend',
  key: '',
  withCredentials: true,
})
